/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Vocabulary_DescInputs */

const en_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Custom Vocabulary feature allows users to enhance AI transcription accuracy by providing specialized vocabulary and pronunciation guides.`)
};

const fr_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fonctionnalité Vocabulaire personnalisé permet d’améliorer la précision de la transcription IA en fournissant du vocabulaire spécialisé et des guides de prononciation.`)
};

const de_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Funktion „Benutzerdefiniertes Vokabular“ ermöglicht es Benutzern, die Genauigkeit der KI-Transkription zu verbessern, indem sie spezielle Vokabeln und Aussprachehilfen bereitstellen.`)
};

const it_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La funzionalità Vocabolario personalizzato consente agli utenti di migliorare la precisione della trascrizione tramite intelligenza artificiale fornendo vocabolario specializzato e guide alla pronuncia.`)
};

const ru_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функция «Настраиваемый словарь» позволяет пользователям повысить точность транскрипции с помощью ИИ, предоставляя специализированные словари и руководства по произношению.`)
};

const es_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La función Vocabulario personalizado permite a los usuarios mejorar la precisión de la transcripción de IA al proporcionar vocabulario especializado y guías de pronunciación.`)
};

const zh_cn2_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义词汇功能允许用户通过提供专门的词汇和发音指南来提高 AI 转录的准确性。`)
};

const ja_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム語彙機能を使用すると、ユーザーは専門的な語彙と発音ガイドを提供することで、AI の文字起こしの精度を高めることができます。`)
};

const hi_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम वोकैबुलरी फीचर उपयोगकर्ताओं को विशेष शब्दावली और उच्चारण गाइड प्रदान करके एआई ट्रांसक्रिप्शन की सटीकता बढ़ाने की अनुमति देता है।`)
};

const pt_pt2_custom_vocabulary_desc = /** @type {(inputs: Custom_Vocabulary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O recurso de Vocabulário Personalizado permite que os usuários aprimorem a precisão da transcrição por IA, fornecendo vocabulário especializado e guias de pronúncia.`)
};

/**
* | output |
* | --- |
* | "The Custom Vocabulary feature allows users to enhance AI transcription accuracy by providing specialized vocabulary and pronunciation guides." |
*
* @param {Custom_Vocabulary_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_vocabulary_desc = /** @type {((inputs?: Custom_Vocabulary_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Vocabulary_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_vocabulary_desc(inputs)
	if (locale === "de") return de_custom_vocabulary_desc(inputs)
	if (locale === "it") return it_custom_vocabulary_desc(inputs)
	if (locale === "ru") return ru_custom_vocabulary_desc(inputs)
	if (locale === "es") return es_custom_vocabulary_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_vocabulary_desc(inputs)
	if (locale === "ja") return ja_custom_vocabulary_desc(inputs)
	if (locale === "hi") return hi_custom_vocabulary_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_vocabulary_desc(inputs)
	return en_custom_vocabulary_desc(inputs)
});